import React,{ useState,useEffect} from 'react'
import DataTable from '../Components/Molecules/Table/DataTable'
import { users_list } from "../Enums/api_constunts"
import { Dropdown } from 'react-bootstrap';
import _ from "lodash";
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import RadioButton from "../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
import styles from "../../src/Pages/Dashboard/Dashboard.module.scss";
//import styles from "./Dashboard.module.scss";
import HBar from "../Components/Bars/Bars";
import {add_agent,branch_list,get_master_data,get_ifsccodes_data} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";
import moment from "moment";
import { FaArrowLeft } from 'react-icons/fa'; 
import IFSCCodeVerification from "../Pages/IFSCCodeVerification"
import AgentDetails from './AgentDetails';
export default function SalesmanList() {
  /*
md_countries ,\n
md_states , \n 
md_locations ,
md_locations ,\n
  */
const [md_countries, set_md_countries] = useState([])
const [selected_country, set_selected_country] = useState({"id":101,"shortName":"IN","name":"India","phoneCode":91,"order":2,"currencySymbol":"&#8377;","currencyCode":"INR","zipcodeLength":6,"allowNumAndCharInZipcode":"","mapName":"INDIA","currency_name":"Rupee","created_on":"2024-11-23T09:02:31","updated_on":null,"label":"India"})


const [md_states, set_md_states] = useState([])
const [selected_state, set_selected_state] = useState(null)
const [md_locations, set_md_locations] = useState([])
const [selected_location, set_selected_location] = useState([])
const minAge =moment().subtract(18,"years").format("YYYY/MM/DD")

const [branchList, setBranchList] = useState([])
const  [selectedRow, setSelectedRow] = useState(null)
const [OpenForm,setOpenForm] = useState(0)
const userData = useSelector((state) => state.auth.user);
const [filterData,setFilterData] = useState({"role_id":[4]})
 const columnDefs = [
    { headerName: "ID", field: "index" ,width: 80},
    { headerName: "Tfs Id", field: "tfs_id" ,width: 80},
    { headerName: "Name", field: "first_name", minWidth:150},
    { headerName: "Email", field: "email",minWidth:150 },
    { headerName: "Phone", field: "mobile_no",minWidth:150 },
    { headerName: "Status", field: "status_details.name",minWidth:150 },
    //{ headerName: "Role", field: "role_details.name",maxWidth:100 },
    { headerName: "Actions", field: "actions",maxWidth:10000 },
  ];

  const [isSpinner, setIsSpinner] = useState(false);
  const handleSubmit = (values) => {
    setIsSpinner(true);
    
     values["tenant_id"] = _.get(selectedTenant,"id");
     values["experience"] =0
     if(_.get(selected_country,"id")){
      values["country_id"] = selected_country["id"]
     }
     if(_.get(selected_state,"id")){
      values["state_id"] = selected_state["id"]
     }
     if(_.get(selected_location,"id")){
      values["location_id"] = selected_location["id"]
     }
     
     if(_.has(values, "date_of_birth") && _.get(values, "date_of_birth","") ){
      values["date_of_birth"] =  moment(values["date_of_birth"]).format("YYYY-MM-DD")
     }

     if(_.has(values,"mobile_no")){
      let mobile_no  = values["mobile_no"].trim()
      if (mobile_no.startsWith("+91-")) {
        
      } else {
        mobile_no = `+91-${mobile_no}`;
      }
      values["mobile_no"] =  mobile_no;

    }
     
     
       
     postMethod(add_agent,values).then((res)=>{
      showToast("success",_.get(res, "message","Successfully added!"))
      setOpenForm(0)
      setIsSpinner(false);
    }).catch ((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

    })
  };

  const [selectedTenant, setSelectedTenant ] = useState(()=>{
    if(_.get(userData, "tenant_details",null) !=null){
        return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
     
      
    }else{
      return null
    }
      
  })
  const getBranchList = ()=>{
    let postData = {
      "search_string": "",
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "status_ids": []
    }
    postMethod(branch_list,postData).then((res)=>{
      if(_.get(res, "list.length") >0){
        let list = res["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        setBranchList(list);
      }
      
    })

  }
  useEffect(()=>{
    //if(OpenForm ==1 && _.get(userData,"role_id") ==1){
      getBranchList();
      getMasterData("md_countries")
      getMasterData("md_states")
    //}
    
  },[OpenForm])
 const [isValiedIfsc, setisValiedIfsc] =useState(null)
  const getMasterData = (category='')=>{
    let postData = {"categories":["md_countries"]};
    if(["md_countries","md_states","md_locations"].indexOf(category)){
      /*country_id": 0,
  "state_id": "string"
*/
      postData = {"categories":[category]};
      if(category=="md_states" && _.get(selected_country, "id", false)){
        postData["country_id"] = selected_country["id"]
      }
      if(category=="md_locations" && _.get(selected_state, "id", false)){
        postData["state_id"] = selected_state["id"]
        if( _.get(selected_country, "id", false)){
          postData["country_id"] = selected_country["id"]
        }
      }
    }
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
      if(category=="md_countries"){   
         set_md_countries( _.get(res,"result.md_countries",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      }
        if(category=="md_states"){        
          set_md_states( _.get(res,"result.md_states",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        }
        if(category=="md_locations"){        
        set_md_locations( _.get(res,"result.md_locations",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        }
      })
  }
  //get_ifsccodes_data
  const [ifsc_code_list, set_ifsc_code_list] = useState([])
  const [selected_ifsc_code, set_selected_ifsc_code]  = useState(null)
  const [ifsc_code_search_txt, set_ifsc_code_search_txt] =useState("");

  const getifscCodes = ()=>{
    
    let postData = {
      "search_string": ifsc_code_search_txt,
      "page": 1,
      "per_page": 5000,
     // "created_on": "2024-12-03",
      //"created_to": "2024-12-03",
      "sort_by": "id",
      "sort_order": "desc"
    };
    
     postMethod(get_ifsccodes_data,postData).then((res)=>{
      console.log(res)
      if(_.get( res,"result.list.length",0)>0){
        let lst =  res["result"]["list"].map((item)=>{ 
          item["id"] =  item["IFSC"];
           item["label"] =  item["IFSC"];
           if(_.has( item, "BRANCH")){
            item["label"] =  `${item["label"]} ${item["BRANCH"]}` 
           }
           if(_.has( item, "CITY1")){
            item["label"] =  `${item["label"]} ${item["CITY1"]}` 
           }
           return item});
        set_ifsc_code_list(lst);
      }else{
        set_ifsc_code_list([]);
      }

      
      })
  }

  useEffect(()=>{
    //getifscCodes()
  },[ifsc_code_search_txt]);


  useEffect(()=>{
    if(_.has(selected_country,"id")){
      getMasterData("md_states")

    }
    if(_.has(selected_state,"id")){
      getMasterData("md_locations")

    }

  },[selected_country,selected_state])

  /*
  
  {
  "email": "user@example.com",
  "first_name": "string",
  "last_name": "string",
  "mobile_no": "string",
  "experience": 0,
  "profile_image": "string",
  "role_id": 0,
  "tenant_id": 0
}
  */
 let formData = {
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required")
    .min(2, "Must be at least 2 characters")
    .max(50, "Must be 50 characters or less"),
  first_name: Yup.string()
    .required("First name is required")
    .min(2, "Must be at least 2 characters")
    .max(50, "Must be 50 characters or less"),
  last_name: Yup.string()
    .required("Last name is required")
    .min(1, "Must be at least 2 characters")
    .max(50, "Must be 50 characters or less"),
    date_of_birth:Yup.string().required("Date of birth is required"),
    gender:Yup.string().required("Gender is required"),
    
  mobile_no: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9 + -]+$/, "Only numbers are allowed")
    .min(10, "Must be at least 10 characters")
    .max(15, "Must be 15 characters"),
    passport: Yup.string()
    .required("PAN Card is required"),
    aadhaar_card: Yup.string()
    .required("Aadhaar Card is required"), 
    selfie: Yup.string().required("Selfie is required"),

   //country_id:Yup.number().required("Country is required"),
   //state_id:Yup.string().required("State is required"),
   //location_id:Yup.string().required("Location is required"),

    present_address:Yup.string().required("Present Address is required"),
    pincode:Yup.string().required("Pincode is required").matches(/^[0-9]+$/, "Only numbers are allowed"),
    present_occupation:Yup.string().required("Present Occupation is required"),
    employer_name:Yup.string().required("Employer Name is required"),
    qualification:Yup.string().required("Qualification is required"),

    account_holder_name:Yup.string().required("Account Holder Name is required"),
    bank_name:Yup.string().required("Bank Name is required"),
    bank_account_number:Yup.string().required("Bank Account Number is required").matches(/^[0-9 a-z A-Z]+$/, "Only alph numarics are allowed"),
    ifsc_code:Yup.string().required("Ifsc code is required"),
    upload_check:Yup.string().required("Canceled cheque is required"),
    referrals:"",


    experience: Yup.string()
    .matches(/^[0-9 .]+$/, "Only numbers are allowed")

}
let initialValues ={
  email: "",
  first_name: "",
  last_name: "",
  date_of_birth:"",
  gender:'',
  mobile_no: "",
  aternate_mobile_no:'',
  passport:"",
  aadhaar_card:"",
  selfie:"",

 //Details
  country_id:101,
  present_address:"",
  pincode:null,
  present_occupation:'',
  employer_name:"",
  qualification:'',

  //Bank Details
  account_holder_name:"",
  bank_name:'',
  bank_account_number:'',
  ifsc_code:"",
  upload_check:"",
  referrals:"",

  experience: 0,
  profile_image:"",
  role_id: 4,
  tenant_id:_.get(selectedTenant,"id")
  
}
const gender_list = [{"id":"Male", "label":"Male"},{"id":"Female", "label":"Female"},{"id":"Other", "label":"Other"}]
if(_.get(userData,"tenant_id") ==1){
  formData["tenant_id"] = Yup.number()
  .required("Branch is required")
  //.matches(/^[1-9 + -]+$/, "Only numbers are allowed")
  //initialValues["tenant_id"] = _.get(selectedTenant,"name","somthing")
}

  let formik = useFormik({
    initialValues:initialValues,
    validationSchema: Yup.object(formData),
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: true,
  });

  
  const getDetails = (row,type)=>{
    if(type=="DETAILS"){
      setSelectedRow(row);
      setOpenForm(2)

    }else{
    setSelectedRow(row)
    formik.setFieldValue("email", _.get(row,"email",""))
    formik.setFieldValue("first_name", _.get(row,"first_name",""))
    formik.setFieldValue("last_name", _.get(row,"last_name",""))
    formik.setFieldValue("mobile_no", _.get(row,"mobile_no",""))
    formik.setFieldValue("experience", _.get(row,"experience",0))
    if(_.get(row,"admin_tenant_details",false)){
      setSelectedTenant(row["admin_tenant_details"])
      formik.setFieldValue("tenant_id", _.get(row,"admin_tenant_details.id",""))
    }
    
   
    
  }

  }

  useEffect(()=>{
    if(OpenForm ==0){
      formik.resetForm();
      setSelectedRow(null)
    }
   
  },[OpenForm])

  
  const handleFile = (event ,file_type='') => {
    const selectedFile = event.target.files[0];
    
    
    if (selectedFile) {
      // Validate if the file is an image
      formik.setFieldValue(file_type, ""); 
      if (selectedFile.type.startsWith('image/') ) {       
        
        const reader = new FileReader();
        reader.onloadend = () => {
         let data = {"file_name":selectedFile.name ,path:reader.result}
          formik.setFieldValue(file_type, JSON.stringify(data))
          
        };
        reader.readAsDataURL(selectedFile); // Convert to Base64
       
      } else {
        formik.setFieldValue(file_type, ""); // Clear the file if it's invalid
        formik.setFieldError(file_type, 'Please upload an image file (jpg, png, gif).');
        event.target.value=null
      }
    }
  };

  return (
    <div>
      

      <div className="d-flex align-items-center mb-3">
         {OpenForm>0 && <div style={{"cursor":"pointer"}} onClick={()=>{setOpenForm(0)}} className="mr-1000 cursor-pointer arrow"><FaArrowLeft size={20}   /></div>} {/* Back arrow icon */}
      
       <h3> 
         { OpenForm==0?"Agents List":OpenForm==1?"Add Agent":OpenForm==2?"Agent Details":"" }
      </h3>
      </div>
        <div className={'mt-3'}>
           {OpenForm ==0 && <DataTable loaded_from="AGENT_LIST" columnDefs={columnDefs} apiUrl={users_list} setFilterData={setFilterData} filterData={filterData} setOpenForm={(v)=>{ setOpenForm(1)}} editRow={(item,type)=>{getDetails(item,type)}} showCreateBtn={true} />}
          
          {/*Create form 
          
          email: "",
      first_name: "",
      last_name: "",
      mobile_no: "",
      experience: "",
      role_id: 3,
          
          */}
          { OpenForm ==1 && <>
            <Card className="">
            <div className="pt-1">
            {/* First Row */}
              <div className="row">
                {/* <div className="col-md-12"> <div className="p-1 border bg-light text-center"> Add Agents
                </div>
                </div> */}
               
                <div className="col-md-4 mb-2">
                  <FormField
                    label="First Name"
                    id="first_name"
                    name="first_name"
                    type="text"
                    value={formik.values.first_name}
                    onChange={(e) =>
                      formik.setFieldValue("first_name", e.target.value)
                    }
                    error={formik.touched.first_name && formik.errors.first_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.first_name && (
                    <ErrorLabel
                      name="first_name"
                      formik={formik}
                      message={formik.errors.first_name}
                    />
                  )}
                </div>

                <div className="col-md-4 mb-2">
                  <FormField
                    label="Last Name"
                    id="last_name"
                    name="last_name"
                    type="text"
                    value={formik.values.last_name}
                    onChange={(e) =>
                      formik.setFieldValue("last_name", e.target.value)
                    }
                    error={formik.touched.last_name && formik.errors.last_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.last_name && (
                    <ErrorLabel
                      name="last_name"
                      formik={formik}
                      message={formik.errors.last_name}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Email"
                    id="email"
                    name="email"
                    type="text"
                    value={formik.values.email}
                    onChange={(e) =>
                      formik.setFieldValue("email", e.target.value)
                    }
                    error={formik.touched.email && formik.errors.email}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && (
                    <ErrorLabel
                      name="email"
                      formik={formik}
                      message={formik.errors.email}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                 
                  <FormDropdown
                    id="gender"
                    name="gender"
                    label="Select Gender"
                    options={gender_list}
                    onChange={(selected) => {
                      
                                           
                      if (selected?.label) {
                        
                        formik.setFieldValue("gender", selected?.label);
                        
                      }
                    }}
                    value={formik?.values?.gender}
                    error={
                      formik.touched.gender && formik.errors.gender
                    }
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    disabled={false}
                  />
                  {formik.touched.gender && (
                    <ErrorLabel  name="gender" formik={formik}  message={formik.errors.gender}  />
                  )}
                </div>

                <div className="col-md-4 mb-2">
                  <SingleDatePicker
                      selectedDate={formik.values.date_of_birth}
                      onDateChange={(date) => {
                        formik.setFieldValue("date_of_birth", date)
                        
                      }}
                      label="Date Of Birth"
                      placeholder="YYYY/MM/DD"
                      
                      maxDate={minAge}
                      datePickerClass={styles.datePickerClass}
                    />
                  {formik.touched.date_of_birth && (
                    <ErrorLabel  name="date_of_birth" formik={formik}  message={formik.errors.date_of_birth}  />
                  )}
                </div>                 
                
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Mobile Number"
                    id="mobile_no"
                    name="mobile_no"
                    type="text"
                    value={formik.values.mobile_no}
                    onChange={(e) =>
                      formik.setFieldValue("mobile_no", e.target.value)
                    }
                    error={formik.touched.mobile_no && formik.errors.mobile_no}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.mobile_no && (
                    <ErrorLabel
                      name="mobile_no"
                      formik={formik}
                      message={formik.errors.mobile_no}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Aternate mobile number"
                    id="aternate_mobile_no"
                    name="aternate_mobile_no"
                    type="text"
                    value={formik.values.aternate_mobile_no}
                    onChange={(e) =>
                      formik.setFieldValue("aternate_mobile_no", e.target.value)
                    }
                    error={formik.touched.aternate_mobile_no && formik.errors.aternate_mobile_no}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.aternate_mobile_no && (
                    <ErrorLabel  name="aternate_mobile_no"  formik={formik}  message={formik.errors.aternate_mobile_no}  />
                  )}
                </div>

                <div className="col-md-4 mb-2">
                  <FormDropdown
                    id="tenant_id"
                    name="tenant_id"
                    label="Select Branch"
                    options={branchList}
                    onChange={(selected) => {
                      setSelectedTenant({...selected})
                      
                      if (selected?.id) {
                        
                        formik.setFieldValue("tenant_id", selected?.id);
                      }
                    }}
                    value={formik?.values?.tenant_id}
                    error={
                      formik.touched.tenant_id && formik.errors.tenant_id
                    }
                    isImportant={_.get(userData,"role_id") ==1}
                    onBlur={formik.handleBlur}
                    disabled={_.get(userData,"role_id") !=1}
                  />
                  {formik.touched.tenant_id && (
                    <ErrorLabel  name="tenant_id" formik={formik}  message={formik.errors.tenant_id}  />
                  )}
                </div>                
                
              </div>
              <div className="row">
                <div className="col-md-12"> <div className="p-1 border bg-light text-center"> Details </div></div>
                
                <div className="col-md-4 mb-2 mt-3"> {/* Corrected margin-top */}
                  <div className="mb-3">
                      <label htmlFor="passport" className="form-label">PAN Card</label>
                      <input  className="form-control"  type="file" name="passport" id="passport" onChange={(e)=>{ handleFile(e,"passport") }}  />
                      {formik.touched.passport && (
                        <ErrorLabel  name="passport" formik={formik}  message={formik.errors.passport}  />
                      )}
                    
                  </div>
                </div>
                <div className="col-md-4 mb-2 mt-3"> 
                  <div className="mb-3">
                      <label htmlFor="aadhaar_card" className="form-label">Aadhaar Card</label>
                      <input  className="form-control"  type="file" name="aadhaar_card" id="aadhaar_card" onChange={(e)=>{ handleFile(e,"aadhaar_card") }}  />
                      {formik.touched.aadhaar_card && (
                        <ErrorLabel  name="aadhaar_card" formik={formik}  message={formik.errors.aadhaar_card}  />
                      )}
                    
                  </div>
                </div>
                <div className="col-md-4 mb-2 mt-3"> 
                  <div className="mb-3">
                      <label htmlFor="selfie" className="form-label">Selfie</label>
                      <input  className="form-control"  type="file" name="selfie" id="selfie" onChange={(e)=>{ handleFile(e,"selfie") }}  />
                      {formik.touched.selfie && (
                        <ErrorLabel  name="selfie" formik={formik}  message={formik.errors.selfie}  />
                      )}
                    
                  </div>
                </div>
         
                 <div className="col-md-4 mb-2">
                  
                 <FormDropdown
                    id="country_id"
                    name="country_id"
                    label="Select Country"
                    options={md_countries}
                    onChange={(selected) => {
                      set_selected_country({...selected})
                      
                      
                      
                      if (selected?.id) {
                        set_md_states([])
                        set_md_locations([])
                        set_selected_state(null)
                        set_selected_location(null)
                        formik.setFieldValue("country_id", selected?.label);
                        
                      }
                    }}
                    value={selected_country?.label}
                    error={
                      formik.touched.country_id && formik.errors.country_id
                    }
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    disabled={false}
                  />
                  
                  {formik.touched.country_id && (
                    <ErrorLabel  name="country_id" formik={formik}  message={formik.errors.country_id}  />
                  )}
              
                </div>
                        
              
                <div className="col-md-4 mb-2">
                            
                { 
                   <FormDropdown
                    id="stateid"
                    name="stateid"
                    label="Select State"
                    options={md_states}
                    onChange={(selected) => {
                      set_selected_state({...selected})
                     
                      
                      if (selected?.label) {
                        set_md_locations([])
                        set_selected_location(null)                        
                        formik.setFieldValue("stateid", selected?.label);                        
                      }
                    }}
                    value={selected_state?.label}
                    error={
                      formik.touched.stateid && formik.errors.stateid
                    }
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    disabled={false}
                  />
                }
                  {formik.touched.stateid && (
                    <ErrorLabel  name="stateid" formik={formik}  message={formik.errors.stateid}  />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                 
                  <FormDropdown
                    id="locationid"
                    name="locationid"
                    label="Select Location"
                    options={md_locations}
                    onChange={(selected) => {
                      set_selected_location({...selected})
                                           
                      if (selected?.label) {
                        
                        formik.setFieldValue("locationid", selected?.label);
                        
                      }
                    }}
                    value={selected_location?.label}
                    error={
                      formik.touched.locationid && formik.errors.locationid
                    }
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    disabled={false}
                  />
                  {formik.touched.locationid && (
                    <ErrorLabel  name="locationid" formik={formik}  message={formik.errors.locationid}  />
                  )}
                </div>                 
                
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Present Address"
                    id="present_address"
                    name="present_address"
                    type="text"
                    value={formik.values.present_address}
                    onChange={(e) =>
                      formik.setFieldValue("present_address", e.target.value)
                    }
                    error={formik.touched.present_address && formik.errors.present_address}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.present_address && (
                    <ErrorLabel
                      name="present_address"
                      formik={formik}
                      message={formik.errors.present_address}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Pincode"
                    id="pincode"
                    name="pincode"
                    type="text"
                    value={formik.values.pincode}
                    onChange={(e) =>
                      formik.setFieldValue("pincode", e.target.value)
                    }
                    error={formik.touched.pincode && formik.errors.pincode}
                    disableNumbers={false}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.pincode && (
                    <ErrorLabel
                      name="pincode"
                      formik={formik}
                      message={formik.errors.pincode}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Present Occupation"
                    id="present_occupation"
                    name="present_occupation"
                    type="text"
                    value={formik.values.present_occupation}
                    onChange={(e) =>
                      formik.setFieldValue("present_occupation", e.target.value)
                    }
                    error={formik.touched.present_occupation && formik.errors.present_occupation}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.present_occupation && (
                    <ErrorLabel
                      name="present_occupation"
                      formik={formik}
                      message={formik.errors.present_occupation}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Employer Name"
                    id="employer_name"
                    name="employer_name"
                    type="text"
                    value={formik.values.employer_name}
                    onChange={(e) =>
                      formik.setFieldValue("employer_name", e.target.value)
                    }
                    error={formik.touched.employer_name && formik.errors.employer_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.employer_name && (
                    <ErrorLabel
                      name="employer_name"
                      formik={formik}
                      message={formik.errors.employer_name}
                    />
                  )}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Qualification"
                    id="qualification"
                    name="qualification"
                    type="text"
                    value={formik.values.qualification}
                    onChange={(e) =>
                      formik.setFieldValue("qualification", e.target.value)
                    }
                    error={formik.touched.qualification && formik.errors.qualification}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.qualification && (
                    <ErrorLabel
                      name="qualification"
                      formik={formik}
                      message={formik.errors.qualification}
                    />
                  )}
                </div>
              </div>
              <div className="row">
                
                <div className="col-md-12 mb-3"> <div className="p-1 border bg-light text-center">Bank Details </div></div>
                  <div className="col-md-4 mb-2">
                    <FormField
                      label="Account Holder Name"
                      id="account_holder_name"
                      name="account_holder_name"
                      type="text"
                      value={formik.values.account_holder_name}
                      onChange={(e) =>
                        formik.setFieldValue("account_holder_name", e.target.value)
                      }
                      error={formik.touched.account_holder_name && formik.errors.account_holder_name}
                      disableNumbers={true}
                      disableSymbols={true}
                      isImportant={true}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.account_holder_name && (
                      <ErrorLabel
                        name="account_holder_name"
                        formik={formik}
                        message={formik.errors.account_holder_name}
                      />
                    )}
                  </div>
                  <div className="col-md-4 mb-2">
                    <FormField
                      label="Account Number"
                      id="bank_account_number"
                      name="bank_account_number"
                      type="text"
                      value={formik.values.bank_account_number}
                      onChange={(e) =>
                        formik.setFieldValue("bank_account_number", e.target.value)
                      }
                      error={formik.touched.bank_account_number && formik.errors.bank_account_number}
                      disableNumbers={false}
                      disableSymbols={true}
                      isImportant={true}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.bank_account_number && (
                      <ErrorLabel name="bank_account_number" formik={formik} message={formik.errors.bank_account_number} />
                    )}
                  </div>
                  <div className="col-md-4 mb-2">
                    <FormField
                      label="Bank Name"
                      id="bank_name"
                      name="bank_name"
                      type="text"
                      value={formik.values.bank_name}
                      onChange={(e) =>
                        formik.setFieldValue("bank_name", e.target.value)
                      }
                      error={formik.touched.bank_name && formik.errors.bank_name}
                      disableNumbers={true}
                      disableSymbols={true}
                      isImportant={true}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.bank_name && (
                      <ErrorLabel
                        name="bank_name"
                        formik={formik}
                        message={formik.errors.bank_name}
                      />
                    )}
                  </div>
                  
                  <IFSCCodeVerification
                    formik={formik}
                    onChange={(value) =>{
                      setisValiedIfsc(value?.isValied)
                      //{"ifscCode":ifscCode,"isValied":true}
                      formik.setFieldValue("ifsc_code",value?.ifscCode);
                      formik.setFieldValue("ifsccode",value?.ifscCode)
                      }
                    }
                    />
                    
                    {isValiedIfsc ==false && (
                      <ErrorLabel  name="ifsc_code"  formik={formik}  message={formik.errors.ifsc_code}   />
                    )}
                    

                  
                  <div className="col-md-4 mb-2"> {/* Corrected margin-top */}
                 
                      <label htmlFor="upload_check" className="form-label">Cheque</label>
                      <input  className="form-control"  type="file" name="upload_check" id="upload_check" onChange={(e)=>{ handleFile(e,"upload_check") }}  />
                      {formik.touched.upload_check && (
                        <ErrorLabel  name="upload_check" formik={formik}  message={formik.errors.upload_check}  />
                      )}
                    
                 
                </div>
                
              
                </div>

              <div className="row justify-content-end w-100">
            <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
              <CancelButton label="Cancel" onClick={()=>setOpenForm(0)} className="btn btn-secondary" />
              <PrimaryButton
                type="submit"
                onClick={formik.handleSubmit}
                spinner={isSpinner}
                label={_.get(selectedRow,"id")?"Update":"Submit"}
                disabled={isSpinner}
                //disabled={!(formik.dirty && formik.isValid)}
              />
            </div>
          </div>
            </div>
          
          </Card>
          
          </> }
          
          {(OpenForm ==2 && _.get(selectedRow,"id"))&& <AgentDetails selected_user={selectedRow}  backAction={()=>{ setOpenForm(0)}} />}
        </div>
    </div>
  )
}
